import { render, staticRenderFns } from "./uploadThePrice.vue?vue&type=template&id=3da4cf12&scoped=true"
import script from "./uploadThePrice.vue?vue&type=script&lang=js"
export * from "./uploadThePrice.vue?vue&type=script&lang=js"
import style0 from "./uploadThePrice.vue?vue&type=style&index=0&id=3da4cf12&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4cf12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da4cf12')) {
      api.createRecord('3da4cf12', component.options)
    } else {
      api.reload('3da4cf12', component.options)
    }
    module.hot.accept("./uploadThePrice.vue?vue&type=template&id=3da4cf12&scoped=true", function () {
      api.rerender('3da4cf12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/uploadThePrice.vue"
export default component.exports